'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.yearsUntil;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/yearsUntil.js
// module id = 367
// module chunks = 0